// v2/constants/kvkk.js — KVKK Aydinlatma Metni (eski giris ekranindaki metnin aynisi)
export const KVKK_BASLIK = 'KVKK Sözleşmesi ve Aydınlatma Metni';

export const KVKK_METIN = [
  {
    baslik: null,
    paragraflar: [
      'Değerli Müşterilerimiz; As Otomotiv Enerji San ve Tic A.Ş ("AS OTOMOTİV" veya "Şirket") olarak 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında, uygulamalarımız ve haklarınız ile ilgili sizleri bilgilendirmek isteriz.',
      'KVKK\'da düzenlenen "Veri Sorumlusunun Aydınlatma Yükümlülüğü" başlıklı 10. madde ile "İlgili Kişinin Hakları" başlıklı 11. madde çerçevesinde; kişisel verilerinizin hangi amaçla işleneceği, işlenen kişisel verilerinizin kimlere ve hangi amaçla aktarılabileceği, kişisel verilerinizin toplanmasının yöntemi ve hukuki sebebi ile KVKK\'nın 11. maddesinde sayılan diğer haklarınızla ilgili olarak sizleri bilgilendirmek ve aydınlatmak amacıyla işbu Aydınlatma Metnini ("Aydınlatma Metni") bilginize sunmaktayız.',
      'Bize sağladığınız kişisel verilerin gizliliğinin ve güvenliğinin korunması As Otomotiv için önemli bir konudur. Bu doğrultuda; kişisel verilerinizi yetkisiz erişim veya bu bilgilerin kaybı, hatalı kullanımı, ifşa edilmesi, değiştirilmesi veya imha edilmesine karşı bilgi güvenliği standartları ve prosedürleri çerçevesinde korumak için gerekli teknik ve idari güvenlik tedbirlerini almaktayız.',
    ],
  },
  {
    baslik: '1) Veri Sorumlusunun Kimliği',
    paragraflar: [
      'Veri Sorumlusu, Gaziantep Ticaret Sicili nezdinde 17090 sicil numarası ile kayıtlı, 008604401500019 Mersis numaralı, şirket merkezi Küsget San. Sit. Anafartalar Bulv. As Otomotiv Plaza No:1 Şehitkamil/GAZİANTEP adresinde bulunan As Otomotiv Enerji San ve Tic A.Ş\'dir.',
    ],
  },
  {
    baslik: '2) Kişisel Verilerin İşleme Amaçları',
    paragraflar: [
      'Kişisel verileriniz, KVKK\'nın 5. maddesinde belirtilen kişisel veri işleme şartlarından bir veya birkaçına dayalı olarak veya açık rızanıza dayalı olarak işlenmektedir.',
    ],
  },
  {
    baslik: '3) Hakkınızda hangi kişisel verileri hangi yollarla topluyoruz?',
    paragraflar: [
      'Doğrudan sizin tarafınızdan sağlanan kişisel veriler: Tarafımıza sizin ilettiğiniz tüm bilgi ve belgeler.',
    ],
  },
  {
    baslik: '4) Kişisel Verilerinizin Kimlere ve Hangi Amaçla Aktarılabileceği',
    paragraflar: [
      'Kişisel verileriniz, yukarıda sayılan amaçların gerçekleştirilmesini sağlamak amacı ile mevzuatta belirlenen güvenlik ve gizlilik esasları uyarınca yeterli ve etkili önlemler alınmak kaydıyla paylaşılabilecek ve aktarılabilecektir.',
    ],
  },
  {
    baslik: '5) Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi',
    paragraflar: [
      'Kişisel verileriniz, As Otomotiv tarafından otomatik ya da otomatik olmayan yollarla, yazılı, sözlü ya da elektronik ortamda toplanabilmektedir.',
    ],
  },
  {
    baslik: '6) Kişisel Veri Sahibinin 6698 sayılı Kanun\'un 11. maddesinde Sayılan Hakları',
    paragraflar: [
      'Kişisel veri sahipleri olarak Kanun\'un 11. Maddesi uyarınca haklarınız bulunmaktadır.',
      'KVKK\'nın 13. maddesi gereğince yukarıda belirtilen haklarınızı kullanmaya yönelik talebinizi, deniz.sarica@as-otomotiv.com.tr e-posta adresimize güvenli elektronik imzalı olarak gönderebilir veya kimliğinizi tespit edici belgeler ile Küsget San. Site Anafartalar Bulv. As Otomotiv Plaza No:1 Şehitkamil/GAZİANTEP adresine ıslak imzalı bir dilekçe ile elden teslim edebilir ya da noter aracılığıyla iletebilirsiniz.',
    ],
  },
];
